
<div class="header">
    <link rel="shortcut icon" href="img/favicon.png" type="image/x-icon">
    <title>SFI Compliance User Guide</title>
    <!-- Bootstrap CSS -->
</div>

    <div class="body_wrapper">
        <header class="">
            <nav class="navbar navbar-expand-lg menu_one">
                <div class="container">
                      <a class="navbar-brand" href="#"><img src="../../assets/img/logo.png" srcset="../../assets/img/logo.png" alt="logo"></a>
                </div>
            </nav>
        </header>

        <!-- <section>
            <div class="banner_top">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h2 class="f_p f_size_30 l_height60 wow fadeInUp text-center" data-wow-delay="0.3s"><span class="f_700">SFI Compliance User Guide </span></h2>
                            <form class="mailchimp wow fadeInUp pb_30" data-wow-delay="0.7s" method="post">
                                <div class="input-group subcribes">
                                    <input type="text" name="EMAIL" class="form-control memail" placeholder="Describe your issue">
                                    <button class="btn btn_submit f_size_15 f_500" type="submit">Search</button>
                                </div>
                                <p class="mchimp-errmessage" style="display: none;"></p>
                                <p class="mchimp-sucmessage" style="display: none;"></p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

         <section class="pos_developer_product_area sec_pad">
            <div class="container">
                <div class="hosting_title text-center">
                    <h3 class="wow fadeInUp" data-wow-delay="0.3s"> {{title | uppercase}}</h3>
                </div>
                <div class="row">
                    <div class="col-lg-4 pr_20 pb_30">
                        <div class="job_info">
                        <div class="info_head">
                            <h6 class="f_p f_600 f_size_18 t_color3">Help Topics</h6>
                        </div>
                        <div class="info_item">
                            <span class="f_size_15"> <a class="onclickLink" (click)="onClickLink(1)"> SFI OFFICE INSPECTION ABATEMENT PROCESS 2022 </a> </span>
                        </div>
                        <div class="info_item">
                            <span class="f_size_15"> <a class="onclickLink" (click)="onClickLink(2)"> SFI WORKPLACE SAFETY CHECKLIST ABATEMENT PROCESS </a> </span>
                        </div>
                        <div class="info_item">
                            <span class="f_size_15"> <a class="onclickLink" (click)="onClickLink(3)"> SFI INSPECTION ABATEMENT PROCESS </a> </span>
                        </div>
                        
                    </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="job_info">
                            <div class="d-flex align-items-center">
                                <div class="developer_product_content">
                                    <ul class="nav nav-tabs develor_tab mb-30" id="myTab2" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active show onclickLink" data-tab="tab_one" id="ruby-tab" data-toggle="tab" data-target="#ruby" role="tab" aria-controls="ruby" aria-selected="true">Browser</a>
                                        </li>
                                        <!-- <li class="nav-item">
                                            <a class="nav-link onclickLink" data-tab="tab_two" id="curl-tab" data-toggle="tab" data-target="#curl"   role="tab" aria-controls="curl" aria-selected="false">iPad</a>
                                        </li> -->
                                        <li class="nav-item">
                                            <a class="nav-link onclickLink" data-tab="tab_three" data-toggle="tab"  role="tab" data-target="#resize" aria-controls="resize" aria-selected="false">Mobile App</a>
                                        </li>
                                    </ul>
                                    <div class="tab-content developer_tab_content">
                                        <div class="tab-pane fade active show" id="ruby" role="tabpanel" aria-labelledby="ruby-tab">
                                            <div *ngFor="let item of stepsList">
                                                <p class="theme_color1" *ngIf="item.id == 1">{{item.desc}}</p>
                                                <p class="theme_color1" *ngIf="item.id == 2 || item.id == 3">Access database at <a href="www.sficompliance.com">www.sficompliance.com</a> and then click on Client Login or go directly to the Data Management System (DMS) <a href="https://dms.sficompliance.com">https://dms.sficompliance.com</a></p>
                                            <hr> 
                                            <p class="theme_color1">{{item.step}} <a *ngIf="item.id == 1" href="www.sficompliance.com">www.sficompliance.com</a></p>
                                            <img class="mtb_15 m-width step2Src" src={{item.src}}>
                                            </div>
                                        </div>
                                        <!-- <div class="tab-pane fade" id="curl" role="tabpanel" aria-labelledby="curl-tab">
                                            <div *ngFor="let item of stepsList">
                                                <p>{{item.desc}}</p>
                                            <hr> 
                                            <p>{{item.step}}</p>
                                            <img class="mtb_15 m-width steptabSrc" src={{item.srctab}}>
                                            </div>
                                        </div> -->
                                        <div class="tab-pane fade" id="resize" role="tabpanel" aria-labelledby="resize-tab">
                                            <div *ngFor="let item of stepsList">
                                                <p class="theme_color1" *ngIf="item.id == 1">{{item.desc}}</p>
                                                <p class="theme_color1" *ngIf="item.id == 2 || item.id == 3">Access database at <a href="www.sficompliance.com">www.sficompliance.com</a> and then click on Client Login or go directly to the Data Management System (DMS) <a href="https://dms.sficompliance.com">https://dms.sficompliance.com</a></p>
                                            <hr> 
                                            <p class="theme_color1 fontSize">{{item.step}} <a *ngIf="item.id == 1" href="www.sficompliance.com">www.sficompliance.com</a></p>
                                            <img *ngIf="item.srcMob != ''" class="mtb_15 m-width stepmobSrc" src={{item.srcMob}}>
                                            </div>
                                        </div>
            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- <footer class="footer_area f_bg">
            <div class="footer_bottom">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-4 col-md-5 col-sm-6">
                            <p class="mb-0 f_400">Copyright © 2023</p>
                        </div>
                        <div class="col-lg-4 col-md-3 col-sm-6">
                            <!-- <div class="f_social_icon_two text-center">
                                <a href="#"><i class="ti-facebook"></i></a>
                                <a href="#"><i class="ti-twitter-alt"></i></a>
                                <a href="#"><i class="ti-vimeo-alt"></i></a>
                                <a href="#"><i class="ti-pinterest"></i></a>
                            </div> -->
                        <!-- </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <ul class="list-unstyled f_menu text-right">
                                <li><a href="#">Terms of Use</a></li>
                                <li><a href="#">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer> --> 
    </div>

    <!-- <script src="js/jquery-3.2.1.min.js"></script>
    <script src="js/propper.js"></script>
    <script src="js/bootstrap.min.js"></script>
 
    <script src="js/plugins.js"></script>

    <script src="js/main.js"></script> -->
